export default {
  install(Vue) {
    Vue.filter('array', array => array?.reduce((a, b) => `${a}${a ? ', ' : ''}${b}`, '') || '');
  },
};
